module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_compare-7cd9b34ef2de8ed8926905c9f735edb0.jpg";